import { useComplaintDialog } from "./DialogContext";
import successIcon from "../../../../assets/icons/successIcon.svg";
import { ComplaintModalLayout } from "./ComplaintModalLayout";
import HeadingDialog from "../../../../components/UI/viewDialogs/HeadingDialog";

ComplaintModalLayout.Header = function Header() {
  const { successView } = useComplaintDialog();
  if (successView) {
    return (
      <>
        <img src={successIcon} alt="sucess" className="mx-auto mb-1 w-9" />
        <p className="view-success-msg-d">Complaint Successfully Created!</p>
      </>
    );
  }

  return <HeadingDialog heading="Complaint Details" />;
};
